import styled from 'styled-components';

const MainContainer = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

export default MainContainer;
